var AllowedErrorFieldsEnum;
(function (AllowedErrorFieldsEnum) {
    AllowedErrorFieldsEnum["code"] = "code";
    AllowedErrorFieldsEnum["name"] = "name";
    AllowedErrorFieldsEnum["message"] = "message";
    AllowedErrorFieldsEnum["severity"] = "severity";
    AllowedErrorFieldsEnum["httpCode"] = "httpCode";
    AllowedErrorFieldsEnum["status"] = "status";
    AllowedErrorFieldsEnum["url"] = "url";
    AllowedErrorFieldsEnum["falcorPaths"] = "falcorPaths";
    AllowedErrorFieldsEnum["fallbackState"] = "fallbackState";
    AllowedErrorFieldsEnum["line"] = "line";
    AllowedErrorFieldsEnum["column"] = "column";
    AllowedErrorFieldsEnum["sourceUrl"] = "sourceUrl";
    AllowedErrorFieldsEnum["detail"] = "detail";
    AllowedErrorFieldsEnum["stack"] = "stack";
})(AllowedErrorFieldsEnum || (AllowedErrorFieldsEnum = {}));

export { AllowedErrorFieldsEnum };
